import { CUSTOM_QUESTIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const applyFormCustomQuestionsSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CUSTOM_QUESTIONS_ACTION_TYPE.GET_CUSTOM_QUESTIONS_SCHEMA:
      return payload;

    default:
      return state;
  }
};

export default applyFormCustomQuestionsSchemaReducer;
